<template>
  <div>
    <a-breadcrumb>
      <a-breadcrumb-item>设置</a-breadcrumb-item>
      <a-breadcrumb-item>运营管理</a-breadcrumb-item>
      <a-breadcrumb-item><router-link to="/systemSetting/manage/coin">会议投币管理</router-link></a-breadcrumb-item>
      <a-breadcrumb-item>发起投币</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="body-content">
      <div class="body-title">申请上会待投币项目</div>
      <a-input-search @search="handleSearch" placeholder="按项目名称搜索" v-model="keyword" style="width: 200px" />
    </div>
    <div class="body-table">
      <a-table :columns="columns" :data-source="data" :pagination="false" rowKey="id">
        <template slot="action" slot-scope="data">
          <a-button type="primary" @click="showCreateModal(data)">发起投币</a-button>
          <a-button class="btn" @click="hideNoticeModal(data)">不再显示</a-button>
        </template>
      </a-table>
      <!-- 分页 -->
      <div class="pagination-buttom">
        <a-pagination v-if="total > pageSize" :total="total" :page-size="pageSize" @change="onChange" :show-total="total => `共有 ${total} 条数据`">
        </a-pagination>
      </div>
      <!-- 分页end -->
    </div>
    <a-modal :visible="showModal === 'hideNotice'" title="提示" @cancel="closeNoticeModal()" @ok="hideCoin" width="700px">
      <div class="company-notice">{{ companyObj.companyName }}项目，{{ companyObj.roundName }}轮次</div>
      <div class="notice-div">点击【不再显示】后，该项目则不会出现在申请上会待投币项目列表中。操作后不能恢复请仔细核对。</div>
    </a-modal>
    <a-modal :visible="showModal === 'createTable'" title="发起投币" @cancel="closeCreateModal" @ok="createCoin" width="700px">
      <div class="create-body">
        <a-row class="body-info">
          <a-col :span="12" class="flex"
            ><div class="body-item">项目名称：</div>
            {{ companyObj.companyName }}</a-col
          >
          <a-col :span="12" class="flex"
            ><div class="body-item">轮次：</div>
            {{ companyObj.roundName }}轮</a-col
          >
          <a-col :span="12" class="padding-div flex"
            ><div class="body-item">DL：</div>
            {{ companyObj.dealLeadersName }}
            <!--  -->
          </a-col>
          <a-col :span="12" class="padding-div flex">
            <div class="body-item">上会时间：</div>
            {{ companyObj.time }}
          </a-col>
        </a-row>
        <hr class="hr-style" />
        <div class="support-body">
          <div class="support-title">投币人：</div>
          <div class="support-content">
            <select-member :userlist="evaluatorList || []" @chose="choseEvaluatorId" @delChosenUser="delEvaluatorId" :multiChoose="true"></select-member>
          </div>
        </div>
        <div class="support-body">
          <div class="support-title">被投币人：</div>
          <div class="support-content">
            <select-member :userlist="icList || []" @chose="choseIcId" @delChosenUser="delIcId" :multiChoose="true"></select-member>
          </div>
        </div>

        <div class="explanation">
          <div>点击确认，投币人将会收到投币链接</div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { unCreateList, hideCoin, createCoin } from '@/api/coin.js';
import { queryMeetingObtainUser } from '@/api/meeting.js';
import moment from 'moment';
import selectMember from '@/components/project/selectMember.vue';
import { mapGetters } from 'vuex';
import { meetingCategoryMap, meetingGoalMap } from '@/utils/meeting.ts';

const columns = [
  {
    title: '项目名称',
    dataIndex: 'companyName',
    key: 'companyName'
  },
  {
    title: '轮次',
    dataIndex: 'roundName',
    key: 'roundName',
    width: 100,
    customRender: data => {
      return data + '轮';
    }
  },
  {
    title: '上会分类',
    dataIndex: 'meetingCategory',
    align: 'center',
    width: '100px',
    key: 'meetingCategory',
    customRender: val => {
      return meetingCategoryMap[val];
    }
  },
  {
    title: '上会目的',
    dataIndex: 'meetingGoal',
    align: 'center',
    key: 'meetingGoal',
    width: '200px',
    customRender: val => {
      return meetingGoalMap[val];
    }
  },
  {
    title: '上会时间',
    dataIndex: 'time',
    align: 'center',
    key: 'time',
    width: '100'
  },
  {
    title: 'DL',
    dataIndex: 'dealLeadersName',
    align: 'center',
    width: '80px',
    key: 'dlName'
  },
  {
    title: 'DM',
    dataIndex: 'dealMembersName',
    key: 'dmStr',
    width: '10%',
    align: 'center'
  },
  {
    title: '操作',
    align: 'center',
    width: '250px',
    scopedSlots: {
      customRender: 'action'
    }
  }
];

export default {
  components: { selectMember },
  data() {
    return {
      columns: columns,
      data: [],
      keyword: '',
      total: 0,
      pageSize: 10,
      showModal: '',
      companyObj: {},
      meetingCategoryMap: meetingCategoryMap,
      meetingGoalMap: meetingGoalMap,
      page: 1,
      icList: [],
      evaluatorList: [],
      loading: false,
      id: undefined
    };
  },
  async mounted() {
    this.id = this.$route.query.id;
    await this.getList();
    if (this.id) {
      this.showCreateModal(this.data[0]);
    }
      
  },
  methods: {
    hideNoticeModal(data) {
      this.showModal = 'hideNotice';
      this.companyObj = data;
    },
    closeNoticeModal() {
      this.showModal = '';
      this.companyObj = {};
    },
    async hideCoin() {
      try {
        let res = await hideCoin({ id: this.companyObj.id });
        if (res.code === 200) {
          this.$message.success('操作成功');
          this.closeNoticeModal();
          if (this.data.length === 1 && this.page > 1) {
            this.page = this.page - 1;
          }
          this.getList();
        }
      } catch (err) {
        console.log(err);
      }
    },
    handleSearch() {
      this.page = 1;
      this.getList();
    },

    onChange(page, pageSize) {
      this.page = page;
      this.getList();
    },
    async showCreateModal(data) {
      this.showModal = 'createTable';
      this.companyObj = data;
      let users = await this.queryMeetingObtainUser(data.meetingProjectId);
      //1=deal team,  2=IC,  3=主持人， 4=参会同学, 5=报名-贡献观点， 6=报名-旁听学习
      // 被投币人，默认将会议安排时的IC带入，多选，可增删进行调整。
      this.icList = users.filter(i => i.type === 2);
      // 包含投币人，默认将会议安排时的deal team 和主持人成员带入，多选，可增删进行调整
      this.evaluatorList = users.filter(i => i.type === 1 || i.type === 3);
    },
    async queryMeetingObtainUser(meetingId) {
      let res = await queryMeetingObtainUser({ meetingProjectId: meetingId });
      if (res.code === 200) {
        return res.data;
      }
      return [];
    },
    choseIcId(val) {
      this.icList = val;
    },

    delIcId(val, index) {
      this.icList = this.icList.filter(_ => _.id !== val.id);
    },
    choseEvaluatorId(val) {
      this.evaluatorList = val;
    },
    delEvaluatorId(val, index) {
      this.evaluatorList = this.evaluatorList.filter(_ => _.id !== val.id);
    },
    async createCoin() {
      if (this.icList.length === 0) {
        this.$message.warn('请选择投币人');
        return;
      }
      if (this.evaluatorList.length === 0) {
        this.$message.warn('请选择被投币人');
        return;
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      let res = await createCoin({
        id: this.companyObj.id,
        icList: this.icList.map(i => i.id),
        evaluatorList: this.evaluatorList.map(i => i.id)
      });
      this.loading = false;
      if (res.code === 200) {
        if (this.data.length === 1 && this.page > 1) {
          this.page = this.page - 1;
        }
        this.getList();
        this.closeCreateModal();
      }
    },

    closeCreateModal() {
      this.showModal = '';
      this.companyObj = {};
      this.evaluatorList = [];
      this.icList = [];
    },
    async getList() {
      try {
        let res = await unCreateList({ page: this.page, pageSize: this.pageSize, companyName: this.keyword, id: this.id });
        if (res.code === 200) {
          this.data =
            res.data.list.map(_ => {
              return {
                ..._,
                time: _.meetingDate ? moment(_.meetingDate * 1000).format('YYYY-MM') : ''
              };
            }) || [];
          this.total = res.data.total;
        }
      } catch (err) {
        console.log(err);
      } finally {
        return Promise.resolve();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.body-content {
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  .body-title {
    font-weight: bold;
    font-size: 14px;
  }
}
.body-table {
  padding: 20px 30px 0px 30px;
  .btn {
    margin-left: 20px;
    color: @red;
    border-color: @red;
  }
}
.pagination-buttom {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.company-notice {
  padding: 0px 30px;
  font-weight: bold;
}
.notice-div {
  padding: 10px 30px;
  color: @red;
}
.create-body {
  padding: 0 20px;
  .body-info {
    padding-bottom: 15px;
    .body-item {
      width: 100px;
      text-align: right;
    }
    .padding-div {
      padding-top: 10px;
    }
  }
  .hr-style {
    border: 1px solid #e8e8e8;
  }
  .support-body {
    padding: 15px 0px;
    display: flex;
    .support-title {
      width: 100px;
      text-align: right;
    }
    .support-content {
      display: flex;
      flex-wrap: wrap;
    }
    .checkbox {
      padding-right: 15px;
    }
  }
  .menu-btn {
    padding-left: 0px;
  }
  .explanation {
    padding: 20px 0px 0px 95px;
    margin-bottom: -20px;
  }
}
.flex {
  display: flex;
}
</style>
